import React from "react";
import { Box, Typography } from "@mui/material";

const AudioReels = ({ audioItems = [] }) => {
  if (!audioItems.length) {
    return null;
  }

  const truncateTitle = (title, limit = 30) => {
    if (!title) return "";
    return title.length > limit
      ? title.substring(0, limit) + "..."
      : title;
  };

  return (
    <Box sx={{ padding: 1 }}>
      {audioItems.map((item, index) => (
        <Box key={index} mt={2}>
          <Typography variant="subtitle2" gutterBottom>
            {truncateTitle(item.mediaTitle)}
          </Typography>

          <audio controls style={{ width: "100%" }}>
            <source src={item.mediaName}/>
            Your browser does not support the audio element.
          </audio>
        </Box>
      ))}
    </Box>
  );
};

export default AudioReels;
